import { Box, Stack } from "@mui/material";
import { CbhIcon, Pill, Text } from "@src/appV2/redesign/system/ui-components";
import pluralize from "pluralize";

import { Button } from "../components/Button";
import { TopRightCloseButton } from "../components/TopRightCloseButton";
import { isRebrandingEnabled } from "../system/ui-theme";

interface ReactivationBonusBannerProps {
  bonusAmountInDollars: number;
  requiredShiftCount: number;
  startDate: string;
  deadlineDate: string;
  title?: string;
  description?: string;
  buttonLabel?: string;
  onClick: () => void;
  onDismiss: () => void;
}

export function ReactivationBonusBanner(props: ReactivationBonusBannerProps) {
  const {
    bonusAmountInDollars,
    requiredShiftCount,
    startDate,
    deadlineDate,
    title,
    description,
    buttonLabel,
    onClick,
    onDismiss,
  } = props;

  const shiftText = `${requiredShiftCount} ${pluralize("shift", requiredShiftCount)}`;

  return (
    <Box sx={{ position: "relative" }}>
      <TopRightCloseButton onClick={onDismiss} />
      <Stack
        sx={(theme) => ({
          padding: theme.spacing(5),
          borderRadius: theme.borderRadius?.medium,
          background: isRebrandingEnabled()
            ? theme.palette.background.default
            : theme.palette.intent?.success.background,
          height: "100%",
          position: "relative",
          overflow: "hidden",
        })}
      >
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
            transform: "translate(15%, 15%)",
            opacity: 0.15,
          }}
        >
          <CbhIcon type="gift-lavender-colored" size="large" />
        </Box>
        <Pill
          label="New"
          size="small"
          {...(isRebrandingEnabled() && {
            backgroundColor: (theme) => theme.palette.intent?.success.background,
            color: (theme) => theme.palette.intent?.success.text,
          })}
          sx={{
            alignSelf: "flex-start",
            position: "relative",
          }}
        />
        <Stack
          gap={5}
          sx={{ flex: 1, justifyContent: "space-between", marginTop: 2, position: "relative" }}
        >
          <Stack gap={3}>
            <Text bold variant="h4">
              {title ?? `Limited Offer: $${bonusAmountInDollars} Bonus`}
            </Text>
            <Text
              variant="body2"
              sx={{ color: (theme) => theme.palette.text.secondary, maxWidth: "70%" }}
            >
              {description ??
                `Book and complete ${shiftText} between ${startDate} and ${deadlineDate}`}
            </Text>
          </Stack>
          <Button
            variant="contained"
            size="small"
            sx={{ alignSelf: "flex-start" }}
            onClick={onClick}
          >
            {buttonLabel ?? "Learn more"}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
